// extracted by mini-css-extract-plugin
module.exports = {"PressArticlePage":"styles_PressArticlePage___FLfj","PressListPage":"styles_PressListPage__dxtpr","stickyNav":"styles_stickyNav__w0A5a"};